// extracted by mini-css-extract-plugin
export default {"HeaderGridCellLayout":"dummy-table-header-cell-module__HeaderGridCellLayout__asb4fxm"};